export default {
  MMS_IMAGE: 'MMS 이미지',
  NORMAL_IMAGE: '친구톡 일반 이미지',
  WIDE_IMAGE: '친구톡 와이드 이미지',
  WIDE_ITEM_LIST_IMAGE: '친구톡 와이드 아이템 이미지',
  CAROUSEL_FEED_IMAGE: '친구톡 캐러셀피드 이미지',
  CAROUSEL_COMMERCE_IMAGE: '친구톡 캐러셀커머스 이미지',
  ALIMTALK_IMAGE: '알림톡 이미지',
  ALIMTALK_ITEM_HIGHLIGHT_IMAGE: '하이라이트 이미지',
  brand: {
    NORMAL_IMAGE: '브랜드 일반 이미지',
    MAIN_WIDE_IMAGE: '브랜드 와이드 이미지',
    WIDE_IMAGE: '브랜드 와이드 이미지',
    MAIN_WIDE_ITEM_LIST_IMAGE: '브랜드 메인 와이드 아이템 이미지',
    WIDE_ITEM_LIST_IMAGE: '브랜드 와이드 아이템 이미지',
    CAROUSEL_FEED_IMAGE: '브랜드 캐러셀피드 이미지',
    CAROUSEL_COMMERCE_IMAGE: '브랜드 캐러셀커머스 이미지',
  },
};
